import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dl-custom-confirmation-dialog',
  templateUrl: './custom-confirmation-dialog.component.html',
  styleUrls: ['./custom-confirmation-dialog.component.scss']
})
export class CustomConfirmationDialogComponent implements OnInit {

  constructor(
     @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; confirmButtonText?: string }
  ) { }

  ngOnInit(): void {
  }

}
